import React from 'react';
import Moment from '../../../components/utils/Moment';

export default class ClientTest extends React.Component {

  render() {

    return (
    <div className="row">
      <div className="col-md-12">
          <h2 className="name">
            {this.props.data.employerCodeNumber} |{' '}
            {this.props.data.employerCodeDescription}
          </h2>

          <hr className="simple" />
          <span>Employer Code: {this.props.data.employerCode}</span>
          <br />
          <span>Group: {this.props.data.groupName} </span>
          <br />
          <span>Group Number: {this.props.data.groupNumber}</span>
          <br />
          <span>Last Updated at: <Moment
            date={this.props.data.updatedAt}
            format="MM/DD/YYYY HH:mm"
          /></span>
          <br />
          <span>Primary Clinic: {this.props.data.primaryClinic}</span>
          <br />
          <span>Eligible Employees: {this.props.data.eligibleEmployees}</span>
          <br />
          <span>Total Enrollment: {this.props.data.totalEnrollment}</span>
            
          <hr className="simple" />
          <dl className="">
            <dt>Address</dt>
            <dd>
              {this.props.data.address1}, {this.props.data.address2},{' '}
              {this.props.data.city}, {this.props.data.state} {this.props.data.zip}{' '}
            </dd>
            <dd>
              Main: {this.props.data.phone1}
            </dd>
            <dd>
              Fax: {this.props.data.fax1}
            </dd>
            <br />

            <dt>Client Relations Manager</dt>
            <dd>
              {this.props.data.clientManager
                ? this.props.data.clientManager.firstName + " " + this.props.data.clientManager.lastName
                : 'Not Assigned'}{' '}
            </dd>
            {this.props.data.clientManager && (
              <dd>
                Work Phone: {this.props.data.clientManager.workPhone}
              </dd>
            )}
            {this.props.data.clientManager && (
              <dd>
                Mobile: {this.props.data.clientManager.mobilePhone}
              </dd>
            )}
            {this.props.data.clientManager && (
              <dd>
                Email: {this.props.data.clientManager.email}
              </dd>
            )}
            <br />

            <dt>Primary Contact Person</dt>
            <dd>
              {this.props.data.primaryContactFName}{' '}
              {this.props.data.primaryContactLName}{' '}
            </dd>
            <dd>{this.props.data.primaryContactPhone1} </dd>
            <dd>{this.props.data.primaryContactEmail} </dd>
            <br />

            <dt>Secondary Contact</dt>
            <dd>
              {this.props.data.secondaryContactFName}{' '}
              {this.props.data.secondaryContactLName}{' '}
            </dd>
            <dd>{this.props.data.secondaryContactPhone1} </dd>
            <dd>{this.props.data.secondaryContactEmail} </dd>
          </dl>
      </div>
    </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/routes/dashboard/components/ClientTest.js